import { Power } from 'react-feather';
import { CardText, CardTitle, Col, Row } from 'reactstrap';
import source from '@src/assets/images/pages/create-account.svg';
import { useBrand } from '@hooks/useBrand';
import logo from '@src/assets/images/logo/logo.png';
import { Link, useHistory } from 'react-router-dom';
import api from '@src/services/api';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import useJwt from '@src/auth/jwt/useJwt';
import { handleLogout } from '@src/redux/actions/auth';
import './styles.scss';
import { useEffect, useState } from 'react';
import { getHomeRouteForLoggedInUser } from '@src/utility/Utils';
import { useSignedTerms } from '@src/services/hooks/VerificationSigningTerms/useVerificationSigningTerms';

export function NoticeOfUnsignedTerms() {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const history = useHistory();
  const [nameAdmin, setNameAdmin] = useState('');
  const [emailAdmin, setEmailAdmin] = useState('');
  const [loading, setLoading] = useState(true);
  const { brand, nameTab } = useBrand();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = useJwt.getToken();
        const response = await api.get('/company/representative', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const { name, email } = response.data.admin;
        const formattedName = name.toUpperCase();
        setEmailAdmin(response.data.admin.email);
        setNameAdmin(formattedName);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  const handleClickLogout = async () => {
    await api.post('logout', null, {
      headers: {
        Authorization: `Bearer ${useJwt.getToken()}`,
      },
    });
    dispatch(handleLogout());
    queryClient.removeQueries();
    history.push('/login');
  };
  const userData = JSON.parse(localStorage.getItem('userData') ?? 'null');
  const token = localStorage.getItem('accessToken') || '';
  const { isLoading, data } = useSignedTerms(token);

  if (isLoading) {
    return null;
  }
  // redirect dos termos antigos
  // if (data.isSigned || userData.isTheSupportt) {
  //   history.push(getHomeRouteForLoggedInUser(userData.role));
  // }
  window.history.pushState(null, '', window.location.pathname);
  if (loading) {
    return <div>Carregando...</div>;
  }
  return (
    <div className="auth-wrapper auth-v2">
      <Row className="auth-inner m-0">
        <Col
          className="d-none d-lg-flex align-items-center p-0 position-relative"
          lg="3"
          sm="12"
        >
          <div className="w-100 d-lg-flex align-items-center justify-content-center">
            <img className="img-fluid w-100" src={source} alt="Login Cover" />
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link
              className="brand-logo position-absolute"
              style={{
                top: '10%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
              to="#"
            >
              {nameTab.toLowerCase() !== 'ultrapayments' ? (
                <img
                  src={brand}
                  alt={`Logo ${nameTab}`}
                  className="img-fluid"
                  style={{ width: '189px' }}
                />
              ) : (
                <img
                  src={logo}
                  alt="Logo Ultrapayments"
                  className="img-fluid"
                />
              )}
            </Link>
          </div>
        </Col>
        <Col
          className="auth-bg px-2 px-sm-3 px-lg-5 pt-3 mb-5 pb-3"
          lg="9"
          sm="12"
        >
          <Row className="justify-content-center">
            <Col className="d-flex flex-column justify-content-center align-items-center">
              <CardTitle className="mb-1" tag="h1">
                Acesso Bloqueado
              </CardTitle>
              <div>
                Para liberar o acesso a plataforma Kosmos, será necessário que o
                administrador {nameAdmin} assine os documentos a seguir:
                <strong> Termo de Serviço</strong> e{' '}
                <strong>Politica de Privacidade</strong>.
              </div>
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            <button
              style={{ bottom: 20, right: 20 }}
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => handleClickLogout()}
            >
              <Power size={14} className="mr-75" />
              <span className="align-middle">Sair</span>
            </button>
          </div>
          <hr style={{ paddingBottom: '30px' }} />
          <div>
            <span>
              Entre em contato com o administrador e peça que ele logue na
              plataforma e assine eletronicamente os documentos. <br />
              <strong>Contato: </strong>
              {emailAdmin}
            </span>
          </div>
        </Col>
      </Row>
    </div>
  );
}
